import { useCallback, useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { registrarEvento } from "../../analytics";
import "./SelloSbs.css";

// Sello de confiabilidad SBS del footer: replica lo que ya existe en el footer de
// Prestamo Mis Cuotas (pefectivo-front-angular). Los PDF los sirve ms-prestamo desde el
// bucket GCP con Content-Disposition: attachment, asi que un <a download> basta —
// sin axios ni blob, que obligarian a una primitiva de error que este sitio no tiene.
const API_PRESTAMO = "https://apiqtc.miscuotas.com/ms-prestamo/api/";

const DOCUMENTOS = [
  {
    id: "resolucion_sbs",
    texto: "Descargar resolución SBS N.° 01422-2022",
    ruta: "v1/maestra/download-resolucion-sbs",
  },
  {
    id: "sujeto_obligado",
    texto: "Descargar verificación de sujeto obligado",
    ruta: "v1/maestra/download-sujeto-obligado",
  },
];

export function SelloSbs() {
  const [abierto, setAbierto] = useState(false);
  const selloRef = useRef(null);
  const cerrarRef = useRef(null);

  const abrir = () => {
    registrarEvento("click_sello_sbs", { ubicacion: "footer" });
    setAbierto(true);
  };

  // Al cerrar, el foco vuelve al sello: es el unico control del footer sin texto y
  // quien navega con teclado se quedaria sin punto de referencia.
  const cerrar = useCallback(() => {
    setAbierto(false);
    if (selloRef.current) selloRef.current.focus();
  }, []);

  // El modal solo existe mientras esta abierto (nunca oculto con opacity: 0, que sigue
  // expandiendo el scroll y dispara el viewport fantasma en movil), asi que el listener
  // de Esc nace y muere con el.
  useEffect(() => {
    if (!abierto) return;
    if (cerrarRef.current) cerrarRef.current.focus();
    const alPulsarTecla = (evento) => {
      if (evento.key === "Escape") cerrar();
    };
    document.addEventListener("keydown", alPulsarTecla);
    // Sin esto la rueda del raton sigue moviendo la pagina detras del overlay; el sello
    // se pulsa desde el footer, asi que el desplazamiento del fondo se nota.
    const overflowPrevio = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", alPulsarTecla);
      document.body.style.overflow = overflowPrevio;
    };
  }, [abierto, cerrar]);

  return (
    <>
      {/* Las dos lineas enmarcan el sello al ancho del logo, como en el footer de
          Prestamo Mis Cuotas; el bloque es inline-block para heredar la alineacion del
          footer (izquierda en escritorio, centrada en movil por la regla del tema). */}
      <div className="sello-sbs-bloque">
        <hr className="sello-sbs-linea" />
        <button type="button" className="sello-sbs" ref={selloRef} onClick={abrir}
                aria-label="Ver registro y documentos legales">
          {/* alt vacio a proposito: el nombre accesible del boton lo da su aria-label,
              y repetirlo en la imagen lo hace sonar dos veces en un lector de pantalla. */}
          <img className="sello-sbs__img" src="img/logo-sbs-blanco.png" alt=""
               width={360} height={98} loading="lazy" />
        </button>
        <p className="sello-sbs-leyenda">
          Empresa inscrita en el registro de la SBS mediante RESOLUCIÓN N.° 01422-2022
        </p>
        <hr className="sello-sbs-linea" />
      </div>

      {/* El modal se monta en el body, no dentro del footer: el tema global tiene reglas
          como `.footer-contact span { color: #c2c2c2 }` que pisan a una sola clase y
          lavaban el texto de los botones de descarga. Fuera del footer, no le llegan. */}
      {abierto && createPortal(
        <div className="sello-sbs-overlay" onClick={cerrar}>
          <div className="sello-sbs-modal" role="dialog" aria-modal="true"
               aria-labelledby="sello-sbs-titulo" onClick={(evento) => evento.stopPropagation()}>
            <button type="button" className="sello-sbs-modal__cerrar" ref={cerrarRef}
                    onClick={cerrar} aria-label="Cerrar">&times;</button>
            <img className="sello-sbs-modal__logo" src="img/logo.png" alt="Mis Cuotas"
                 width={108} height={56} />
            <h2 className="sello-sbs-modal__titulo" id="sello-sbs-titulo">Registro y documentos legales</h2>
            <p className="sello-sbs-modal__intro">Consulta o descarga la documentación que respalda nuestro registro.</p>
            {DOCUMENTOS.map((documento) => (
              <a className="sello-sbs-modal__descarga" key={documento.id}
                 href={`${API_PRESTAMO}${documento.ruta}`} download
                 onClick={() => registrarEvento("click_documento_legal", { documento: documento.id })}>
                <i className="fas fa-download" aria-hidden="true"></i>
                <span>{documento.texto}</span>
              </a>
            ))}
            <p className="sello-sbs-modal__pie">Número RUC: 20608863762</p>
          </div>
        </div>,
        document.body
      )}
    </>
  );
}
